import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=43d70368&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=43d70368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d70368",
  null
  
)

export default component.exports